import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FieldHolder } from "../../../../constants/assets/DriverDetailsContainers";
import variables from "../../../../constants/assets/variables";
import Checkbox from "sushiweb/InputTypes/Checkbox";
import { capitalizeFirstLetter } from "../../../../utils";
import ErrorModal from "../../../Common/ErrorModal";
import { FieldsContainer } from "../../../../constants/assets/containers";

const DriverServicesEditDetails = ({
  services,
  saveState,
  setSaveState,
  updateDriverServicesDetails,
  driverId,
  getDriverServicesDetails,
}) => {
  const [driverServices, setDriverServices] = useState({});
  const [errors, setErrors] = useState([]);

  const handleChange = (key, val) => {
    const values = { ...driverServices };
    if (key === "Delivery" && values[key]) {
      return;
    }
    values[key] = val;
    setDriverServices(values);
  };

  const checkValidations = (servicesObj) => {
    const flag = Object.keys(servicesObj).reduce(
      (a, b) => a + servicesObj[b],
      false
    );
    return flag > 0;
  };

  const handleSubmit = () => {
    const servicesPresent = checkValidations(driverServices);
    if (servicesPresent) {
      setErrors([]);
      updateDriverServicesDetails(driverId, driverServices).then(() => {
        setSaveState(false);
        getDriverServicesDetails(driverId);
      });
    } else {
      const err = [...errors];
      err.push("Please select atleast one service");
      setSaveState(false);
      setErrors(err);
    }
  };

  const handleErrorModalSubmit = () => {
    setErrors([]);
  };

  useEffect(() => {
    setDriverServices({ ...services });
  }, [services]);

  //to handle click on save button
  useEffect(() => {
    saveState && handleSubmit();
  }, [saveState]);

  return (
    <FieldsContainer>
      <FieldHeading>
        <span>Eligible services</span>
      </FieldHeading>
      {Object.keys(driverServices).map((service, idx) => {
        return (
          <FieldHolder key={idx}>
            <Checkbox
              value={service}
              color={variables.red500}
              checked={driverServices[service]}
              onChange={(e) => handleChange(service, e[service])}
              className="sushi-checkbox"
              label={capitalizeFirstLetter(service)}
            />
          </FieldHolder>
        );
      })}
      {errors.length > 0 && (
        <ErrorModal
          handleSubmit={handleErrorModalSubmit}
          heading="Error while saving"
          errors={errors}
        />
      )}
    </FieldsContainer>
  );
};

const FieldHeading = styled(FieldHolder)`
  span {
    color: ${variables.grey500};
  }
`;

export default DriverServicesEditDetails;
